import * as React from "react";
import type { SVGProps } from "react";
const SvgGithubIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.01 1C18.078 1 23.017 5.958 23 12.09c0 4.904-3.153 9.053-7.528 10.523-.546.11-.747-.24-.747-.533 0-.367.018-1.56.018-3.048 0-1.047-.346-1.708-.747-2.057 2.46-.275 5.03-1.212 5.03-5.472 0-1.212-.419-2.203-1.13-2.974.11-.276.493-1.414-.109-2.938 0 0-.93-.294-3.026 1.138a10.588 10.588 0 0 0-2.752-.367c-.93 0-1.855.124-2.752.367C7.16 5.297 6.23 5.591 6.23 5.591c-.601 1.524-.219 2.662-.11 2.938a4.342 4.342 0 0 0-1.13 2.974c0 4.26 2.57 5.215 5.013 5.472-.31.276-.601.771-.693 1.488-.637.293-2.223.77-3.207-.919 0 0-.584-1.064-1.696-1.138 0 0-1.075 0-.073.68 0 0 .73.33 1.222 1.615 0 0 .637 1.983 3.7 1.322 0 .919.018 1.8.018 2.057 0 .294-.2.643-.747.532A11.082 11.082 0 0 1 1 12.091C1 5.958 5.921 1 12.01 1Z"
    />
  </svg>
);
export default SvgGithubIcon;
